<template>
  <div class="entry-info-box">
    <div class="title">
      <div class="title-left">
        <img src="https://images.snsports.cn/Fszt7IivQB9Yz_leqZnMJcSgyL_z" alt="球队报名表" class="title-logo" />
      </div>
      <div class="title-right" @click="showAction = true">···</div>
    </div>
    <div class="match-info">
      <img :src="imageView(match.icon)" alt="">
      <div class="info">
        <div class="name">{{ match.unionMatchName }}</div>
        <div class="group">
          <span class="group-label">组别</span>
          <span class="group-value">{{ match.group }}</span>
        </div>
      </div>
    </div>
    <!-- 卡片入口：参赛队伍(logo+名称+查看详情) / 队员名单 / 工作人员 -->
    <div class="card-section">
      <div class="card card-full card-team" @click="goTeamInfo">
        <div class="card-team-left">
          <span class="card-title">参赛队伍</span>
          <div class="team-left">
            <div class="team-logo" v-if="team.badge">
              <img :src="imageView(team.badge)" alt="" />
            </div>
            <span class="team-name">{{ team.name || '-' }}</span>
          </div>
        </div>
        <div class="card-team-action">
          <span class="card-link">查看详情</span>
        </div>
      </div>
      <div class="card-row">
        <div class="card card-half card-player" @click="goPlayerList">
          <div class="card-title-row">
            <span class="card-title">队员名单</span>
            <span class="card-link">查看</span>
          </div>
          <div class="card-desc"><span class="num">已入队{{ players.length }}</span>/{{ match.teamMemberLimitCount || 0 }} 人</div>
          <div v-if="showPlayerSelfFill" class="btn-player-self-fill" @click.stop="weChatShare">
            <img src="@/assets/images/wx-round-icon.png" alt="" />
            <span style="margin-left: 3px;">队员自填</span>
          </div>
        </div>
        <div class="card card-half card-officer" v-if="officer" @click="goOfficerList">
          <div class="card-title-row">
            <span class="card-title">工作人员</span>
            <span class="card-link">查看</span>
          </div>
          <div class="card-desc"><span class="num">已加入{{ officers.length }}</span> / {{ match.maxOffice || 0 }} 人</div>
        </div>
        <!-- 参赛费用：仅在开启收费时展示 -->
        <div
          class="card card-half card-fee"
          v-if="match && match.isOpenCharge === 1 && match.feeMethod !== 0"
        >
          <div class="card-title-row">
            <span class="card-title">参赛费用</span>
            <span class="card-link">{{ getPaymentStatus(team.orderStatus) }}</span>
          </div>
          <div class="card-desc">
            报名费：
            <span class="price">¥{{ feeAmountText }}</span>
          </div>
        </div>
        <!-- 协议/声明：状态隐藏，点击提示暂未开启 -->
        <div
          class="card card-half card-agreement"
          @click="onAgreementCardClick"
        >
          <div class="card-title-row">
            <span class="card-title">协议/声明</span>
          </div>
          <div class="card-desc">未开启</div>
          <!-- <div class="card-desc card-desc-sub">3-21 后开启</div> -->
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer">
        <div class="left">
          <div>
            <span v-if="team.isSubmit === 0">未提交</span>
            <span v-else-if="team.auditStatus === 0 || team.auditStatus === 1" style="color: #909399">待确认</span>
            <span v-else-if="team.auditStatus === 3" style="color: #409EFF">已锁定</span>
            <span v-else-if="team.auditStatus === 2" style="color: #409EFF">已确认</span>
            <span v-else-if="team.auditStatus === -1" style="color: #F56C6C">已退回</span>
          </div>
        </div>
        <div class="right" v-if="team.isSubmit === 0 || team.auditStatus === -1" :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }" @click="updateBMMatchTeam()">提交审核</div>
      </div>
    </div>

    <van-action-sheet
      v-model="showAction"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showAction = false"
      @select="handleAction"
    />
    <ShareLayer :shareShow="shareShow" @close="shareShow = false"></ShareLayer>
  </div>
</template>

<script>
import { getBMMatchTeamSignup,bangsaishiCreatePlayerSignupOrder,checkBMMatchBeforeSubmit,submitBMMatchTeam,bangsaishiCreateTeamSignupOrder,cancelBMMatchTeam } from '@/api/match'
import { QNImageUtil, isWeChatMiniApp } from "@/utils";
import { orderStatusOptions } from '@/config'
import Vue from 'vue';
import { ImagePreview,ActionSheet,Dialog,Toast } from 'vant';
Vue.use(ImagePreview).use(ActionSheet).use(Dialog).use(Toast);
import ShareLayer from "@/components/ShareLayer"
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'

export default {
  components: { ShareLayer },
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      team:{},
      match: {},
      players: [],
      officers: [],
      showAction: false,
      actions: [],
      officer: false,
      shareShow: false,
      certTypeColumns: [
        { value: 1, label: '身份证' },
        { value: 11, label: '学籍卡' },
        { value: 2, label: '护照' },
        { value: 3, label: '港澳通行证' },
        { value: 4, label: '台胞证' },
        { value: 5, label: '港澳台回乡证' }
      ],
      jetlympic: false
    };
  },
  computed: {
    /** 是否注册报名类型（与 member-list 一致：注册类型不显示队员自填） */
    isRegisterType() {
      return this.match && this.match.publicSignUp === 2;
    },
    /** 是否显示队员自填按钮：非注册类型且允许队员自填时显示，与 member-list 邀请成员条件一致 */
    showPlayerSelfFill() {
      if (!this.team || !this.match) return false;
      const canEdit = this.team.isSubmit === 0 || this.team.auditStatus === -1;
      if (!canEdit) return false;
      if (this.isRegisterType) return false;
      return this.match.teamLeaderAddPlayerOnly !== 1;
    },
    /** 报名费显示文本：xx.xx/队 或 xx.xx/人 */
    feeAmountText() {
      if (!this.match || !this.match.feeAmount) return '0.00'
      const amount = (this.match.feeAmount / 100).toFixed(2)
      const unit = this.match.feeMethod === 2 ? '队' : '人'
      return `${amount}/${unit}`
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.getBMMatchTeamSignup()
  },
  methods: {
    onAgreementCardClick() {
      Toast('暂未开启')
    },
    getCertType(value) {
      const item = this.certTypeColumns.find(item => item.value === value)
      return item ? item.label : ''
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.matchId,
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          this.team = data.team
          this.match = data.match
          this.players = data.players
          this.officers = data.officers
          if (this.match.teamSignupFields.indexOf('officer') !== -1) {
            this.officer = true
          }
          if (this.team.isSubmit === 0) { // 未提交时可以做的操作
            // this.actions = [{ name: '编辑队伍信息' }]
            if(this.match.teamLeaderTransferOpen === 1) {
              this.actions.push({ name: '移交领队' })
              this.actions.push({ name: '取消报名',color: '#ee0a24' })
            }
          } else if ((this.team.auditStatus === 0 || this.team.auditStatus === 1 || this.team.auditStatus === 2) && this.match.teamLeaderTransferOpen === 1) {  // 提交待审核、已确认、已锁定
            this.actions = [{ name: '移交领队' }]
          } else if (this.team.auditStatus === -1) { // 已退回
            if(this.match.teamLeaderTransferOpen === 1) {
              this.actions = [{ name: '移交领队' }, { name: '取消报名',color: '#ee0a24' }]
            } else {
              this.actions = [{ name: '取消报名',color: '#ee0a24' }]
            }
          }
        }
      })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getPaymentStatus(value) {
      if (this.match.isOpenCharge !== 1) return ''
      if (this.match.feeMethod === 0) return ''
      const order = orderStatusOptions.find(o => o.value == value)
      if (!order) return '待支付'
      return order.label
    },
    previewImg(img) {
      if (!img) return
      ImagePreview([
        this.imageView(img)
      ])
    },
    doPay(item) {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: item.id
      }
      bangsaishiCreatePlayerSignupOrder(params).then(res => {
        if (res) {
          localStorage.setItem('saas-redirect', window.location.href)
          this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&teamId=${this.teamId}&matchId=${this.matchId}&playerId=${item.id}`)
        }
      })
    },
    updateBMMatchTeam() {
      if (this.match.isOpenCharge === 1 && (this.match.feeMethod === 2 || this.match.feeMethod === 3) && this.team.orderStatus != 1 && this.team.orderStatus != 2) {
        /**
         * 先校验
         * TODO
         */
        const params = {
          teamId: this.teamId,
          matchId: this.matchId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId: this.matchId,
                teamId: this.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.matchId}&teamId=${this.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: this.teamId,
          matchId: this.matchId
        }).then(res => {
          if (res) {
            const params = {
              teamId: this.teamId,
              matchId: this.matchId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Toast('提交成功')
                this.getBMMatchTeamSignup()
                // this.$router.back()
              }
            })
          }
        })
      }
    },
    handleAction(item) {
      if (item.name === '编辑队伍信息') {
        this.$router.push(`/entry-page/entry-info-team?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}`)
      } else if (item.name === '移交领队') { 
        this.goTransfer()
      } else if (item.name === '取消报名') {
        this.cancelBMMatchTeam()
      }
    },
    goTransfer() {
      this.$router.push(`/entry-page/transfer-captain?matchId=${this.matchId}&teamId=${this.teamId}`)
    },
    goTeamInfo() {
      this.$router.push(`/entry-page/entry-info-team-detail?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}`)
    },
    goPlayerList() {
      this.$router.push(`/entry-page/member-list?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&type=player`)
    },
    goOfficerList() {
      this.$router.push(`/entry-page/member-list?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&type=officer`)
    },
    cancelBMMatchTeam() {
      if ((this.match.isOpenCharge === 1 && this.match.feeMethod === 1 && this.match.isChargeCount > 0) || (this.match.isOpenCharge === 1 && (this.match.feeMethod === 2 || this.match.feeMethod === 3) && (this.match.orderStatus === 1 || this.match.orderStatus === 2))) {
        Dialog.alert({
          title: '取消失败',
          message: '已有队员支付报名费用，取消报名请联系组委会',
        })
        return
      }
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.$router.back()
          }
        })
      })
    },
    async weChatShare() {
      // 先判断是否在微信环境
      if (!AppType.isInWeChat()) {
        Toast.fail('请在微信环境下打开')
        return
      }
      
      // 判断是否为微信小程序环境
      const isMiniApp = await isWeChatMiniApp()
      
      if (isMiniApp) {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/share/index?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}`
        })
      } else {
        // 微信浏览器环境
        this.shareShow = true
        const shareObj = {
          title: this.team.name + '邀请您加入',
          abstract: this.team.name + '邀请您参加' + (this.match.unionMatchName || '') + '/' + (this.match.group || this.match.matchGroupName || '') + '的比赛',
          link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.matchId + '&teamId=' + this.teamId,
          image: this.match.icon ? QNImageUtil.imageView(this.match.icon) : ''
        }
        this.wxShare(shareObj)
      }
    },
    goPlayer(id) {
      // if(this.players.length >= this.match.teamMemberLimitCount) return Toast('队员数量已达到上限')
      this.$router.push(`/entry-page/player-info?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&playerId=${id || ''}&role=captain`)
    },
    goOfficer(id = '', isAdd = false) {
      if(this.officers.length >= this.match.maxOffice && !isAdd) return Toast('工作人员数量已达到上限')
      this.$router.push(`/entry-page/officer-form?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&officerId=${id}`)
    }
  },
};
</script>

<style scoped lang="scss">
.entry-info-box{
  background: var(--bg2);
  padding: 0 14px;
  min-height: 100vh;
  padding-top: 12px;
  padding-bottom: 100px;
  box-sizing: border-box;
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left{
      display: flex;
      align-items: center;
      .title-logo{
        width: 95px;
        height: 22px;
        display: block;
      }
    }
    .title-right{
      border-radius: 50%;
      background-color: var(--bg1);
      width: 27px;
      height: 27px;
      text-align: center;
      line-height: 27px;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .match-info {
    display: flex;
    align-items: center;
    margin-top: 4px;
    img{
      width: 46px;
      height: 46px;
      border-radius: 50%;
      margin-right: 7px;
    }
    .info{
      .name{
        font-size: 15px;
        font-weight: bold;
      }
      .group{
        display: inline-block;
        border-radius: 70px;
        background-color: var(--bg1);
        overflow: hidden;
        font-size: 0px;
        margin-top: 4px;
        .group-label{
          background-color: #337ECC;
          color: #fff;
          padding: 3px 8px;
          font-size: 12px;
        }
        .group-value{
          font-size: 12px;
          padding: 3px 10px;
        }
      }
    }
  }
  // padding: 12px;
  .team-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: #fff;
    height: 52px;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    img{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 0.75px solid #EEEEEE;
      margin-right: 8px;
    }
    .name{
      font-size: 15px;
      color: #1D2129;
      display: flex;
      align-items: center;
    }
    .status{
      width: 72px;
      height: 22px;
      border-radius: 75px;
      text-align: center;
      line-height: 22px;
      font-size: 13px;
      font-weight: 500;
      color: #FFF;
      background: #DBEBFA;
    }
  }
  .match{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 16px;
    background-color: #fff;
    font-size: 12px;
    color: #999;
    .more{
      color: #30D55B;
    }
  }
  .card-section{
    padding: 0;
    margin-top: 12px;
    .card{
      background: var(--bg1);
      border-radius: 8px;
      padding: 14px 16px;
      // margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-title{
        font-size: 15px;
        color: #1D2129;
        font-weight: 500;
      }
      .card-link{
        font-size: 14px;
        color: #4AA2F7;
      }
    }
    .card-team{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .card-title{
        margin-bottom: 10px;
      }
      .card-team-left{
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .team-left{
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
      }
      .team-logo{
        width: 25px;
        height: 25px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background: #e8e8e8;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .team-name{
        flex: 1;
        min-width: 0;
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .card-team-action{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;
      }
      .card-link{
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-row{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 12px;
      margin-top: 12px;
    }
    .card-half{
      width: 167px;
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      .card-half-left{
        flex: 1;
        min-width: 0;
      }
      .card-desc{
        font-size: 13px;
        color: #666;
        margin-top: 12px;
        .num{
          color: #30D55B;
        }
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
      }
    }
    .card-title-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .card-title{
        margin-bottom: 0;
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-player,
    .card-officer,
    .card-fee,
    .card-agreement{
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      .card-desc{
        margin-top: 12px;
      }
    }
    .card-agreement{
      .card-desc-sub{
        margin-top: 8px;
        font-size: 13px;
        color: #909399;
        display: flex;
        align-items: center;
      }
    }
    .card-player .btn-player-self-fill{
      display: flex;
      align-items: center;
      height: 16px;
      line-height: 16px;
      background: #F5FCEF;
      border-radius: 70px;
      width: 70px;
      font-size: 11px;
      color: #10BC00;
      margin-top: 12px;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
  .footer-box{
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    // box-sizing: border-box;
    height: 88px;
    background-color: #fff;
    // padding-bottom: 12px;
    box-shadow: 0px -2px 10px 0px rgba(0,0,0,0.05);
    .title{
      background: #FFF5EB;
      font-size: 13px;
      color: #3D3D3D;
      padding-left: 12px;
      height: 24px;
      line-height: 24px;
    }
  }
  .footer{
    padding: 6px 12px 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.footer-submit-only{
      justify-content: flex-end;
      .left{
        display: none;
      }
    }
    .left{
      font-size: 14px;
      color: #3D3D3D;
      display: flex;
      align-items: start;
      div{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 22px;
      }
      img{
        width: 27px;
        height: 27px;
        border-radius: 50%;
        margin-bottom: 6px;
      }
    }
    .right{
      width: 117px;
      height: 45px;
      border-radius: 69px;
      background: #509DEA;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
  }
}
</style>
